import React, { useMemo } from "react";
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
} from "chart.js";
import { Bar, Doughnut, Line, Scatter } from "react-chartjs-2";
import { buildInsightChartData, validateInsightChartSpec } from "./insightChartSpec";

ChartJS.register(
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
  Legend
);

const commonOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      labels: { color: "#d8dee8", boxWidth: 10, font: { size: 11 } },
    },
    tooltip: { mode: "nearest", intersect: false },
  },
  scales: {
    x: {
      ticks: { color: "#aeb7c4", maxRotation: 0, autoSkip: true },
      grid: { color: "rgba(255,255,255,0.08)" },
    },
    y: {
      ticks: { color: "#aeb7c4" },
      grid: { color: "rgba(255,255,255,0.08)" },
    },
  },
};

export default function InsightChartRenderer({ chartSpec, scappContext }) {
  const validation = useMemo(() => validateInsightChartSpec(chartSpec), [chartSpec]);
  const chartData = useMemo(
    () => (validation.ok ? buildInsightChartData(chartSpec, scappContext) : null),
    [chartSpec, scappContext, validation.ok]
  );

  if (!validation.ok) {
    return (
      <div className="insight-chart-error">
        {validation.errors.slice(0, 2).join(" ")}
      </div>
    );
  }

  const hasData = chartData?.datasets?.some((dataset) => Array.isArray(dataset.data) && dataset.data.length);
  if (!hasData) {
    return <div className="insight-chart-error">No hay datos suficientes para este gráfico.</div>;
  }

  if (chartSpec.chartType === "doughnut") {
    return <Doughnut data={chartData} options={{ ...commonOptions, scales: undefined }} />;
  }

  if (chartSpec.chartType === "line" || chartSpec.family === "metric_by_time" || chartSpec.family === "derived_metric_by_time") {
    return <Line data={chartData} options={commonOptions} />;
  }

  if (chartSpec.chartType === "scatter" || chartSpec.family === "correlation" || chartSpec.family === "metric_vs_metric") {
    return <Scatter data={chartData} options={commonOptions} />;
  }

  return <Bar data={chartData} options={commonOptions} />;
}

